import { Clause8Home, CustomerComplaintList } from '../../pages/clause8page';

export const clause8 = [
  {
    path: 'clause8',
    element: <Clause8Home />,
  },
  {
    path: 'CustomerComplaintRegister',
    element: <CustomerComplaintList />,
  },
];
